<template>
  <div>
    <div class="list">
      <div class="labels">
        <div>{{ $t('label') }}</div>
        <div>{{ $t('namespace') }}</div>
        <div>{{ $t('lastPing') }}</div>
        <div>{{ $t('status') }}</div>
        <div v-if="item.health.availabilityIssue">{{ $t('availability') }}</div>
        <div v-if="item.health.performanceIssue">{{ $t('performance') }}</div>
        <div>{{ $t('externalIp') }}</div>
        <div v-if="item.provider">{{ $t('provider') }}</div>
      </div>
      <div class="values">
        <div>{{ item.label || '—' }}</div>
        <div>{{ item.namespace }}</div>
        <div>{{ lastPing }}</div>
        <div :class="item.health.status === NodeStatus.ONLINE ? 'success--text' : 'error--text'">{{ item.health.status }}</div>
        <div v-if="item.health.availabilityIssue">
          <app-issue
            :severity="item.health.availabilityIssue.severity"
            :size="18"
            :status="item.health.status"
          >
          </app-issue>
          {{ item.health.availabilityIssue.description }}
        </div>
        <div v-if="item.health.performanceIssue">
          <app-issue
            :severity="item.health.performanceIssue.severity"
            :size="18"
            :status="item.health.status"
          >
          </app-issue>
          {{ item.health.performanceIssue.description }}
        </div>
        <div>{{ item.metadata.externalIp || '—' }}</div>
        <div v-if="item.provider">{{ item.provider }}</div>
      </div>
    </div>
    <div v-if="length > 1" class="nav">
      <v-btn text icon :disabled="page === 1" @click="prev()">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      {{ page }} / {{ length }}
      <v-btn text icon :disabled="page === length" @click="next()">
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import IssueComponent from '@/components/Issue.vue'
import { NodeStatus } from '@/model/node'

export default {
  data () {
    return {
      page: 1,
      NodeStatus
    }
  },
  props: {
    data: Array
  },
  computed: {
    length () {
      return this.data.length
    },
    item () {
      return this.data[this.page - 1]
    },
    lastPing () {
      return formatDistanceToNow(this.item.timestamp, { addSuffix: true })
    }
  },
  watch: {
    data () {
      this.page = 1
    }
  },
  methods: {
    next () {
      if (this.page < this.length) {
        this.page++
      }
    },
    prev () {
      if (this.page > 1) {
        this.page--
      }
    }
  },
  components: {
    'app-issue': IssueComponent
  }
}
</script>


<style lang="scss" scoped>
.list {
  background: #fff;
  display: flex;
  flex-flow: row nowrap;
  padding: .75rem 1.5rem;
}

.labels, .values {
  > div {
    padding: .75rem 0;
    white-space: nowrap;
  }
}

.labels > div {
  color: #777;
  font-weight: 700;
  margin-right: 1rem;
}

.nav {
  border-top: 1px solid #f4f4f4;
  font-weight: 500;
  text-align: center;
  user-select: none;
}
</style>


<i18n>
{
  "en": {
    "label": "Label",
    "namespace": "Namespace",
    "lastPing": "Last Ping",
    "status": "Status",
    "availability": "Availability",
    "performance": "Performance",
    "externalIp": "External IP Address",
    "provider": "Provider"
  }
}
</i18n>
